import { graphql } from 'src/gql'
import { SortFindManyStaffingAgencyHolidayInput } from 'src/gql/graphql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQLDropdownOptions } from 'src/queries/cat/lookups/helpers'

const document = graphql(/* graphql */`
  query staffingAgencyHolidays($sort: SortFindManyStaffingAgencyHolidayInput) {
    lookups {
      StaffingAgencyHoliday {
        many(sort: $sort) {
          _id
          name
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type StaffingAgencyHolidays = NonNullable<NonNullable<NonNullable<NonNullable<TData>['lookups']>['StaffingAgencyHoliday']>['many']>

const useStaffingAgencyHolidays = useGraphQLDropdownOptions(
  document,
  'lookups.StaffingAgencyHoliday.many',
  {
    sort: SortFindManyStaffingAgencyHolidayInput.OrderAsc
  }
)

export { useStaffingAgencyHolidays, document as staffingAgencyHolidaysDocument }
